import SectionHeading from "@/components/base/SectionHeading";
import { testimonials } from "@/mocks/site";

export default function TestimonialsSection() {
  return (
    <section className="px-4 md:px-6 py-14 md:py-20" aria-labelledby="testimonial-title">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          id="testimonial-title"
          eyebrow="投稿人怎么说"
          title="他们投过一次之后，还愿意再投第二次"
          desc="以下反馈来自投稿人自愿留下，姓名与身份信息已按要求隐去。"
        />

        <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex flex-col rounded-lg bg-background-100 border border-background-200 p-5 md:p-6"
            >
              <span className="w-9 h-9 rounded-full bg-accent-500 text-foreground-950 flex items-center justify-center">
                <i className="ri-double-quotes-l text-lg" aria-hidden="true"></i>
              </span>
              <blockquote className="mt-4 flex-1 text-sm md:text-[15px] text-foreground-800 leading-relaxed">
                {item.quote}
              </blockquote>
              <figcaption className="mt-5 pt-4 border-t border-background-200">
                <span className="block font-heading text-sm font-bold text-foreground-950">{item.name}</span>
                <span className="mt-0.5 block text-xs text-foreground-500 font-label">{item.role}</span>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}